import { useTracking } from '@vp/react-tracking';
import React from 'react';
import { FlexBox, Link, Typography } from '@vp/swan';
import { __ } from '@99designs/i18n';
import { transformToAnalyticsUrl } from '../../utils/transformToAnalyticsUrl';
import { addQueryToUrl } from './addQueryToUrl';

interface MoreDesignsCardProps {
    destinationUrl: string;
    destinationPageName: string;
    icon: React.ReactNode;
    title: string;
    position: number;
    destinationUrlQuery?: Record<string, string>;
}

export default function MoreDesignsCard(props: MoreDesignsCardProps) {
    const { tracking } = useTracking();
    const { destinationUrl, destinationPageName, icon, title, position, destinationUrlQuery } =
        props;
    const sourceUrl = window.location.pathname;
    const analyticsDestinationUrl = transformToAnalyticsUrl(destinationUrl);
    const finalDestinationUrl = destinationUrlQuery
        ? addQueryToUrl(destinationUrl, destinationUrlQuery)
        : destinationUrl;
    const ctaValue = `expertServices-${destinationPageName}-startAProject`;
    const sendAnalyticsForMoreDesignsCard = () =>
        tracking.track('Fly-Out Clicked', {
            action: 'Fly-Out Clicked',
            category: 'Fly-Out',
            label: 'My Design Services:Fly-Out',
            eventDetail: `${sourceUrl};${analyticsDestinationUrl};My Design Service flyout CTA;${ctaValue}`,
            navigationDetail: `${ctaValue}:${position}`,
            pageSection: 'Design Services',
            pageStage: 'My Account',
            pageName: 'Design Services:Dashboard',
        });
    return (
        <Link to={finalDestinationUrl} onClick={sendAnalyticsForMoreDesignsCard} skin="unstyled">
            <FlexBox flexDirection="row" alignItems="center" marginBottom={'4'}>
                {icon}
                <Typography fontSkin="body-standard" marginLeft={'3'}>
                    {title}
                </Typography>
            </FlexBox>
        </Link>
    );
}
